import { useState } from 'react';
import usePlayerStats from '../hooks/usePlayerStats';
import GameHistoryModal from './modals/GameHistoryModal';

export default function StatsCard({ userId, playerName }) {
  const { stats, loading } = usePlayerStats(userId);
  const [showHistory, setShowHistory] = useState(false);

  if (loading) {
    return (
      <div className="stats-card">
        <div className="stats-loading">loading stats...</div>
      </div>
    );
  }

  if (!stats || stats.totalGames === 0) {
    return (
      <div className="stats-card">
        <div className="stats-empty">No games yet. Start playing to track your stats!</div>
      </div>
    );
  }

  return (
    <div className="stats-card">
      <div className="stats-header">
        <span className="stats-title">{playerName}'s stats</span>
        <button className="btn-link stats-history-link" onClick={() => setShowHistory(true)}>
          View History
        </button>
      </div>
      <div className="stats-grid">
        <div className="stat-item">
          <span className="stat-value">{stats.totalGames}</span>
          <span className="stat-label">games</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{stats.wins}</span>
          <span className="stat-label">wins</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{stats.winPct}%</span>
          <span className="stat-label">win rate</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{stats.highestScore.toLocaleString()}</span>
          <span className="stat-label">best score</span>
        </div>
      </div>
      <GameHistoryModal
        show={showHistory}
        onClose={() => setShowHistory(false)}
        userId={userId}
        playerName={playerName}
      />
    </div>
  );
}
